// extracted by mini-css-extract-plugin
export default {"autohero":"autohero___DSVnI","private":"private___fxj9W"};